// context/CommentModalContext.tsx
import React, {createContext, useContext, useState, ReactNode} from "react";

type CommentModalContextType = {
  isOpen: boolean;
  loading: boolean;
  openModal: (onConfirm: () => Promise<void>) => void;
  closeModal: () => void;
  confirmDelete: () => void;
};

const CommentModalContext = createContext<CommentModalContextType | undefined>(
  undefined
);

export const useCommentDeleteModal = () => {
  const context = useContext(CommentModalContext);
  if (!context) {
    throw new Error("useCommentModal must be used within CommentModalProvider");
  }
  return context;
};

export const CommentModalProvider = ({children}: {children: ReactNode}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [onConfirmFn, setOnConfirmFn] = useState<() => Promise<void>>(
    () => async () => {}
  );

  const openModal = (onConfirm: () => Promise<void>) => {
    setOnConfirmFn(() => onConfirm);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setLoading(false);
  };

  const confirmDelete = async () => {
    setLoading(true);
    try {
      await onConfirmFn();
    } finally {
      closeModal();
    }
  };

  return (
    <CommentModalContext.Provider
      value={{isOpen, loading, openModal, closeModal, confirmDelete}}>
      {children}
    </CommentModalContext.Provider>
  );
};
